import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_arap_contra_RowClass} from '../../dbschema';

export class GenericDocARAPContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_arap_contra: bl_fi_generic_doc_arap_contra_RowClass = new bl_fi_generic_doc_arap_contra_RowClass();
}
